import React from 'react';
import PropTypes from 'prop-types';
import './InfoButton.css';

/**
 * InfoButton — Configurator
 *
 * Small 18×18 circular "?" button with a tooltip on hover.
 *
 * Figma node: 3815:1665 (parent)
 *   Default: 3815:1664
 *   Hover:   3815:1666
 */

const InfoButton = ({
  tooltip,
  onClick,
  className = '',
  ...props
}) => {
  return (
    <button
      className={`cfg-info-btn ${className}`.trim()}
      onClick={onClick}
      type="button"
      aria-label={tooltip || 'More information'}
      {...props}
    >
      <span className="cfg-info-btn__circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M8.33838 12.6318V11.5723H9.37842V12.6318H8.33838ZM9.04639 6.17188C8.20003 6.17188 7.75081 6.60156 7.69873 7.46094H6.78076C6.81331 6.7806 7.0249 6.26302 7.41553 5.9082C7.80941 5.55013 8.35303 5.37109 9.04639 5.37109C9.48258 5.37109 9.86344 5.44596 10.189 5.5957C10.5145 5.74544 10.7668 5.95703 10.9458 6.23047C11.1281 6.50065 11.2192 6.78874 11.2192 7.09473C11.2192 7.40072 11.1769 7.68066 11.0923 7.93457C11.0109 8.18522 10.7 8.53841 10.1597 8.99414C9.89274 9.21549 9.69743 9.40592 9.57373 9.56543C9.45003 9.72168 9.36377 9.90397 9.31494 10.1123C9.26937 10.3174 9.24658 10.6071 9.24658 10.9814H8.47021V10.6836C8.47021 10.3288 8.49626 10.0407 8.54834 9.81934C8.60042 9.59473 8.69645 9.38802 8.83643 9.19922C8.9764 9.00716 9.1766 8.80046 9.43701 8.5791C9.69743 8.35775 9.8846 8.17708 9.99854 8.03711C10.1125 7.89388 10.1873 7.76204 10.2231 7.6416C10.259 7.52116 10.2769 7.37467 10.2769 7.20215C10.2769 6.88965 10.1662 6.64062 9.94482 6.45508C9.72673 6.26628 9.42725 6.17188 9.04639 6.17188Z" fill="currentColor"/>
        </svg>
      </span>

      {tooltip && (
        <span className="cfg-info-btn__tooltip typo-body-sm">
          {tooltip}
        </span>
      )}
    </button>
  );
};

InfoButton.propTypes = {
  /** Tooltip text shown on hover */
  tooltip: PropTypes.string,
  /** Click handler */
  onClick: PropTypes.func,
  /** Additional CSS class */
  className: PropTypes.string,
};

export default InfoButton;
